import { ReviewCard } from "@components/organism";
import { useReviewUserAccountUser } from "./useReviewUserAccountUser";

export function ReviewUserAccountNewUser() {
    const { newUserFormData, info, navigate, handleSave } = useReviewUserAccountUser();
    
    if (!newUserFormData) {
        return <div className="p-4">Nenhum usuário selecionado para revisão.</div>;
    }

    return (
        <ReviewCard
            title="• Criar conta"
            subtitle="Revise os dados da conta:"
            info={info}
            onPrimaryAction={handleSave}
            onSecondaryAction={() => navigate(`/new-user`)}
            primaryActionLabel="Salvar conta"
            headerLabel="Cliente"
        />
    );
}